import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
      height: "100%",
    },
    content: {
      paddingLeft: theme.spacing(3),
    },
    contentVersion: {
      marginRight: theme.spacing(2),
    }
}));

const ScoreMethodSiteVisitCard = (props) => {
    const [expanded, setExpanded] = React.useState(true);
    const classes = useStyles();
    let text = '';
    const arrParagraph = props.data.split("</p>");
    for (let i = 1; i < arrParagraph.length; i++) {
        text += arrParagraph[i];
    }

    const handleChange = (expand) => () => {
        setExpanded(!expand);
      };
    
    return (
        <Accordion expanded={expanded} onChange={handleChange(expanded)}>
            <AccordionSummary sx={{backgroundColor: "#0A91F3", color: "#fff", fontWeight: "bold"}} expandIcon={<ExpandMoreIcon sx={{color: "#fff"}} />}>
                <div
                    className={classes.content}
                    dangerouslySetInnerHTML={{
                        __html: arrParagraph[0],
                    }}
                ></div>
            </AccordionSummary>
            <AccordionDetails>
                <div
                    className={classes.content}
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                ></div>
            </AccordionDetails>
          </Accordion>
    );
}

export default ScoreMethodSiteVisitCard